/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Servicenow_Id_PlaceholderInputs */

const en_user_servicenow_id_placeholder = /** @type {(inputs: User_Servicenow_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow sys_id`)
};

const ja_user_servicenow_id_placeholder = /** @type {(inputs: User_Servicenow_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow sys_id`)
};

const fr_user_servicenow_id_placeholder = /** @type {(inputs: User_Servicenow_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow sys_id`)
};

const de_user_servicenow_id_placeholder = /** @type {(inputs: User_Servicenow_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ServiceNow sys_id`)
};

/**
* | output |
* | --- |
* | "ServiceNow sys_id" |
*
* @param {User_Servicenow_Id_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_servicenow_id_placeholder = /** @type {((inputs?: User_Servicenow_Id_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Servicenow_Id_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_servicenow_id_placeholder(inputs)
	if (locale === "ja") return ja_user_servicenow_id_placeholder(inputs)
	if (locale === "fr") return fr_user_servicenow_id_placeholder(inputs)
	return de_user_servicenow_id_placeholder(inputs)
});